import {Component} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {Router} from "@angular/router";

@Component({
    selector: "fhm-chrome-control-account",
    templateUrl: "./user-profile-chrome-control.component.html",
    styleUrls: ["./user-profile-chrome-control.component.scss"],
    standalone: false
})
export class UserProfileChromeControlComponent {


    constructor(public auth: AuthApiService, private router: Router) {
    }

    logoutOfGoogle(): void {
        window.location.href = "https://mail.google.com/mail/u/0/?logout&hl=en";
    }

    logout(): void {
        this.auth.logout().then(() => this.router.navigate(["/login"]));
    }


}
